import { compact } from "lodash";
import NotFoundComponent from "PFComponents/not_found/not_found";
import { isSubtemplate } from "PFCore/helpers/templates";
import usePageWrapper from "PFCore/helpers/use_page_wrapper";
import PropTypes from "prop-types";
import React from "react";
import { useTranslation } from "react-i18next";
import { useLocation } from "react-router-dom";

import ActivityEditForm from "./activity_edit_form";
import { useActivityEditPage } from "./use_activity_edit_page";

const initPage = { activity: null, parentActivity: null, attachments: [], template: null, loaded: false };

const ActivityEditPage = ({ id, type, attributes, isClone }) => {
  const location = useLocation();
  const { t } = useTranslation("activities");

  const WrappedActivityEditPage = usePageWrapper(ActivityEditForm);

  const { loaded, activity, parentActivity, attachments, template, subtemplates, errors } =
    useActivityEditPage(initPage, {
      id,
      type,
      attributes: location.state?.attributes ?? attributes,
      isClone
    });

  const isSubtemplateMissing =
    !!activity && !!activity.subtemplate_key && !isSubtemplate(template, activity.subtemplate_key);

  const isNew = !id;
  const templateError = !template && (isNew || !!activity) && t("edit.missingTemplate");
  const subtemplateError = isSubtemplateMissing && t("edit.templateNotSupported");

  return (
    <WrappedActivityEditPage
      loading={!loaded}
      errors={[...(errors || []), ...compact([templateError, subtemplateError])]}
      errorComponent={
        <NotFoundComponent
          message={templateError || subtemplateError || t("edit.activityCouldntLoad")}
          buttonMessage={t("edit.pleaseTryLater")}
          buttonUrl="/"
        />
      }
      isClone={isClone}
      template={template}
      subtemplates={subtemplates}
      activity={activity || {}}
      parentActivity={parentActivity}
      activityAttachments={attachments}
      shortlistsToCopy={location.state?.shortlistsToCopy}
    />
  );
};

export default ActivityEditPage;

ActivityEditPage.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  attributes: PropTypes.object,
  shortlistsToCopy: PropTypes.arrayOf(PropTypes.shape({ profile: PropTypes.object })),
  isClone: PropTypes.bool
};
